







import Vue from 'vue'
import { mdiClose } from '@mdi/js'

export default Vue.extend({
    name: 'BaseBtnCancel',

    computed: {
        icon(): string {
            return mdiClose
        },
    },
})
